import { Fragment } from "react"
import logo from "../images/Logo.avif"

const Footer = ()=>{
    return(
        <Fragment>
            <hr />
            <section id="terms">
                <div class="container p-5" >
                    <div class="row ">
                        <div class="col-lg-6 ">
                            <h4 class="mb-4">Quick links</h4>
                            <p><a href="t and c.html" class="link">Terms and Condition</a></p>
                            <p><a href="deliverypolicy.html" class="link">Delivery Policy</a></p>
                            <p><a href="privacypolicy.html" class="link">Privacy Policy</a></p>
                            <p><a href="return and canc.html" class="link">Return and Cancellation</a></p>
                            <p><a href="refund and ex.html" class="link">Refund and Exchange</a></p>
                        </div>
                        <div class="col-lg-6">
                            <img src={logo} alt="logo-img" />
            
                        </div>
                    </div>

                </div>
      
            </section>
            <hr />
            <section id="footer">
                <div class="container p-4">
                    <div class="row footer-parah ">
                        <div class="col d-flex">
                            <p><i class="fa-regular fa-copyright"></i> 2024,leegifts powered by shopsfy .</p>
                            <p>Refund policy .</p>
                            <p>Privacy policy .</p>
                            <p>Terms of service .</p>
                            <p>shipping policy .</p>
                            <p>contact information .</p>
                        </div>

                    </div>
        
  

                </div>
     
            </section>

        </Fragment>
        
    
    
    )
}
export default Footer;